export const environment = {
  production: false,
  // api_url: 'http://192.168.5.174:8585/rc17_v4',
  // api_url: 'http://192.168.5.179:8585/rc17_v4', // Kiri Prabu
  api_url: 'http://192.168.5.238:8585/rc17_v4', // Yuvaraj
  // api_url: 'http://192.168.5.165:8080/rc', // Mano
  // api_url: 'http://192.168.5.39:8080/rc', // Santo
  // api_url: 'http://192.168.5.174:8585/rc17_v4', // Dinesh
  // api_url: 'https://stg.myrecoverycoach.com/rc', 
  // api_url: 'http://192.168.5.206:8585/rc18_v1', // Sivaprasad
  // api_url: 'http://192.168.5.204:8585/rc18_v1/', // Karthika
  // api_url: 'https://stg.myrecoverycoach.com/rc',
  hrologin_url: 'http://208.40.251.191:3030/spscas/pages/login.html',
  lib_base: 'http://192.168.5.100:1000/dccpdam',
  swfurl: 'http://192.168.5.174:8585/rc17_v4/design/formsAndAssessment.swf?',
  documenturl:  'http://192.168.5.100:1000/dccpdam',
  downloadUrl: 'http://192.168.5.174:8585/rc17_v4/pages/downloadDocument.xhtml?dvalue=',
  surveydownloadUrl: 'http://192.168.5.174:8585/rc17_v4/pages/downloadSurvey.xhtml?dvalue=',
  downloadMultiSurvey: 'http://192.168.5.174:8585/rc17_v4/pages/downloadMultiSurvey.xhtml?dvalue=',
  downloadPatientDocuments: 'http://192.168.5.174:8585/rc17_v4/pages/downloadPatientDocuments.xhtml?dvalue=',
  videoDescriptionurl: 'http://192.168.5.174:8585/rc17_v4/pages/downloadExerciseVideoDescription.xhtml?dvalue=',
  pdfdocumenturl: 'http://192.168.5.174:8585/rc17_v4/pages/downloadDynamicDocument.xhtml?productId=',
  downloadcare: '/pages/downloadPatientExcelReport.xhtml?dvalue=',
  practiceid: 184135,
  imagefileSize: 1000000,
  idletime: 1800, //set idle time before alert
  timeset: 60, // waiting time  
  timelimit: 3000,
  demositesetup: false,
  ipBlocked: false,
  dateFormat: 'MM/DD/YYYY',
  dateForm: 'MM/dd/yyyy',
  vmImageURL: 'http://192.168.5.174:8585/rc17_v4',
  cloudeImageURL: 'http://192.168.5.100:1000/rcngdam',
  onboardImageURL: 'http://s3.us-east-2.amazonaws.com/rcngdam',
  directobgin_url: 'http://onboarding.192.168.5.119:7070/rc17_v4-ob',
  OpBodyPart: "Total Hip Replacement, Total Knee Replacement, Partial Knee Replacement",
  version: "1.4.20"
};